// Entry point for the build script in your package.json

import Rails from "@rails/ujs";
Rails.start();
// require("@rails/activestorage").start();
// require("channels");

// Window animation
import WindowAnimation from "./lib/WindowAnimation";
WindowAnimation.start();

// Stimulus
import { Application } from "stimulus";
import FigureOverlayController from "./controllers/FigureOverlayController";
import MobileNavController from "./controllers/MobileNavController";
const application = Application.start();
application.register("figure-overlay", FigureOverlayController);
application.register("mobile-nav", MobileNavController);
